
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soluzioni/[slug]",
      function () {
        return require("private-next-pages/soluzioni/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soluzioni/[slug]"])
      });
    }
  